/* @flow */
import cx from 'classnames';
import React from 'react';

import CurrentUser from 'auth/CurrentUser';
import Link from 'components/Link.jsx';
import Zopim from 'lib/Zopim';

const ZopimOrSubmitTicketLink = React.createClass({
  getInitialState() {
    return {
      isZopimOnline: Zopim.getCurrentStatus(),
    };
  },

  componentDidMount() {
    Zopim.addStatusListener(status => {
      // XXX a bit of a hack because Zopim doesn't allow you to clear a status listener
      if (this.isMounted()) {
        this.setState({
          isZopimOnline: status === 'online',
        });
      }
    });
  },

  render() {
    // We can't let underage children use live chat.
    if (this.state.isZopimOnline && !(CurrentUser.isSignedIn() && CurrentUser.getUser().isUnderage())) {
      const showZopim = (event) => {
        event.preventDefault();
        event.stopPropagation();
        Zopim.show();
      };
      return (
        <Link
          onClick={showZopim}
          className={cx('ZopimOrSubmitTicketLink', this.props.className)}>
          {this.props.children}
        </Link>
      );
    } else {
      return (
        <Link
          className={cx('ZopimOrSubmitTicketLink', this.props.className)}
          href="https://help.remind.com/hc/en-us/requests/new"
          target="_blank">
          {this.props.children}
        </Link>
      );
    }
  },
});

export default ZopimOrSubmitTicketLink;



// WEBPACK FOOTER //
// ./src/support/components/ZopimOrSubmitTicketLink.jsx